import React from "react";
import { Box, Grid2, Typography } from "@mui/material";
import CustomSkeleton from "../../../components/custom-skeleton/CustomSkeleton";
import styles from "./MyUltrasound.module.scss";
import { useTranslation } from "react-i18next";

const MyUltrasoundsSkeleton: React.FC = () => {
  const { t } = useTranslation();
  return (
    <Box bgcolor={"#f2f0ec"}>
      <Box className={styles.root}>
        <Typography variant="h1" pt={2}>
          {t("myUltrasounds")}
        </Typography>
        <Typography className={styles.bodyText} >
          {t("myUltrasoundsSubText")}
        </Typography>
        <Box className={styles.skeletonGroup}>
          <Box className={styles.card}>
            <Box mb={2} className={styles.center}>
              <CustomSkeleton variant="rectangular" height={32} width="30%" />
            </Box>
            <Box mb={2}>
              <Box mb={2} className={styles.center}>
                <CustomSkeleton variant="rectangular" height={48} width="50%" />
              </Box>
              <Grid2 container spacing={2}>
                {[...Array(4)].map((_, idx) => (
                  <Grid2 key={idx} size={{ xs: 12, sm: 3 }}>
                    <CustomSkeleton
                      variant="rectangular"
                      height={180}
                      sx={{ borderRadius: "24px" }}
                    />
                  </Grid2>
                ))}
              </Grid2>
            </Box>
          </Box>

          <Grid2
            container
            spacing={2}
            px={5}
            sx={{ width: "100%", mx: "auto" }}
          >
            {[...Array(2)].map((_, idx) => (
              <Grid2 key={idx} size={{ xs: 12, sm: 6 }}>
                <CustomSkeleton
                  variant="rectangular"
                  height={200}
                  sx={{ borderRadius: "24px" }}
                />
              </Grid2>
            ))}
          </Grid2>

          <Grid2
            container
            spacing={2}
            pt={2}
            px={5}
            sx={{ width: "100%", mx: "auto" }}
          >
            {[...Array(2)].map((_, idx) => (
              <Grid2 key={idx} size={{ xs: 12, sm: 6 }}>
                <CustomSkeleton
                  variant="rectangular"
                  height={200}
                  sx={{ borderRadius: "24px" }}
                />
              </Grid2>
            ))}
          </Grid2>
        </Box>
      </Box>
    </Box>
  );
};

export default MyUltrasoundsSkeleton;

